
export default {
    SET_BULK_REPORT(state, { bulkReport, total, per_page }) {
      state.bulkReport = bulkReport;
      state.totalPage = total / per_page;
      state.totalItems = total;
    },

    SET_BULK_AUTO_SUBSTITUTING_REPORT(state, { bulkAutoSubstitutingReport, total, per_page }) {
        state.bulkAutoSubstitutingReport = bulkAutoSubstitutingReport;
        state.autoSubstitutingTotalPage = total / per_page;
        state.autoSubstitutingTotalItems = total;
    },

    SET_BULK_SMS(state, { bulkSms, total, per_page }) {
        state.bulkSms = bulkSms;
        state.bulkSmsTotalPage = total / per_page;
        state.bulkSmsTotalItems = total;
    },
  };
  